// extracted by mini-css-extract-plugin
module.exports = {"bookmarkIcon":"bookmark-icon_bookmarkIcon__m_AY0","bookmarkButton":"bookmark-icon_bookmarkButton__sP5Cb"};